export class PasswordChecker {
  errorMessage: string = ''

  /**
   * Проверяет пароль на корректность
   * @param password -- строка пароль
   * @returns {boolean}
   */
  checkPassword (password: string) {
    const regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}/
    let passwordAvailable = false
    this.errorMessage = ''

    if (!this.checkMinLength(password, 8)) {
      this.errorMessage += (this.errorMessage.length > 0) ? ', ' : ''
      this.errorMessage += 'не менее 8 символов'
      passwordAvailable = false
    }

    if (!this.checkAZLow(password)) {
      this.errorMessage += (this.errorMessage.length > 0) ? ', ' : ''
      this.errorMessage += 'хотя бы одну латинскую букву в нижнем регистре'
      passwordAvailable = false
    }

    if (!this.checkAZHigh(password)) {
      this.errorMessage += (this.errorMessage.length > 0) ? ', ' : ''
      this.errorMessage += 'хотя бы одну латинскую букву в верхнем регистре'
      passwordAvailable = false
    }

    if (!this.checkDigit(password)) {
      this.errorMessage += (this.errorMessage.length > 0) ? ', ' : ''
      this.errorMessage += 'хотя бы одну цифру'
      passwordAvailable = false
    }

    if (!regexp.test(password)) {
      this.errorMessage += (this.errorMessage.length > 0) ? '.' : ''
      this.errorMessage = 'Пароль должен содержать ' + this.errorMessage
      passwordAvailable = false
    } else {
      this.errorMessage = 'Пароль введен корректно.'
      passwordAvailable = true
    }
    return passwordAvailable
  }

  /**
   * Проверяет строку на присутствие хотя бы одного строчного латинского символа a-z
   * @param value
   * @returns {boolean}
   */
  checkAZLow (value: string) {
    const regexp = /^(?=.*[a-z])/
    return regexp.test(value.toString())
  }

  /**
   * Проверяет строку на присутствие хотя бы одного строчного латинского символа A-Z
   * @param value
   * @returns {boolean}
   */
  checkAZHigh (value: string) {
    const regexp = /^(?=.*[A-Z])/
    return regexp.test(value.toString())
  }

  /**
   * Проверяет строку на наличие хотя бы одной цифры
   * @param value
   * @returns {boolean}
   */
  checkDigit (value: string) {
    const regexp = /^(?=.*[0-9])/
    return regexp.test(value.toString())
  }

  /**
   * Проверяет строку, что все ее символы являются цифрами
   * @param value
   */
  checkDigitsAll (value: string) {
    console.warn('Проверка на цифры', value)
    const regexp = /^\d+$/
    return regexp.test(value.toString())
  }

  /**
   * Проверяет максимальную длину строки
   * @param value
   * @param size
   * @returns {boolean}
   */
  checkMaxLength (value: any, size: number) {
    return value.toString().length <= size
  }

  /**
   * Проверяет минимальную длину строки
   * @param value
   * @param size
   * @returns {boolean}
   */
  checkMinLength (value: any, size: number) {
    return value.toString().length >= size
  }

  /**
   * Проверка на любой спец. символ, исключая буквы, цифры и знак подчеркивания.
   * @param value
   * @returns {boolean}
   */
  checkSpecialSymbol (value: string) {
    const regexp = /^(?=.*[^\w])/
    return regexp.test(value.toString())
  }
}
